
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pertanyaan-umum/[topicId]",
      function () {
        return require("private-next-pages/pertanyaan-umum/[topicId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pertanyaan-umum/[topicId]"])
      });
    }
  